import EventEmitter from 'events'
import PermissionJSON from '../configs/acl.json'

let state = {
    accessPermission: []
};

class ACLService extends EventEmitter {
    /**
     * Set permission for specific user
     * @param {*} payload 
     */
    setPermissions(payload) {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      if(!payload && (userInfo && userInfo.user_type_id)){
        Object.keys(PermissionJSON).forEach((key) => {
          if(Number(key) === Number(userInfo.user_type_id)){
            state.accessPermission = PermissionJSON[key];
          }
        });
      }else{
        Object.keys(PermissionJSON).forEach((key) => {
          if(key === payload){
            state.accessPermission = PermissionJSON[key];
          }
        });
      }
    }

    /**
     * Get all permissions of a user
     * @param {*} slug 
     */
    getAllPermissions(slug){
        if(state.accessPermission.length === 0){
          return false;
        }
  
        let access = {};
        for(let i = 0; i < state.accessPermission.length; i++){
          if(state.accessPermission[i].slug === slug[0]){
            access = state.accessPermission[i];
            break;
          }
        }
  
        if(access.hasOwnProperty('sub') && slug[1] != undefined){
          let permission = {};
          for(let i = 0; i < access.sub.length; i++){
            if(access.sub[i].slug === slug[1]){
              permission = access.sub[i].acl;
              break;
            }
          }
          return permission;
        }
        return {
          view: false,
          add: false,
          update: false,
          delete: false,
          download: false
        };
    }

    /**
     * Check if user has Permissions 
     * for specific action
     * 
     * @param {*} slug 
     * @param {*} action 
     */
    hasPermission(slug, action) { 
        if(state.accessPermission.length === 0){
          return false;
        }
        let access = {};

        if(Array.isArray(slug)){
          for(let i = 0; i < state.accessPermission.length; i++){
            if(state.accessPermission[i].slug === slug[0]){
              access = state.accessPermission[i];
              break;
            }
          }
          if(access.hasOwnProperty('sub') && slug[1] != undefined){
            let permission = {};
            for(let i = 0; i < access.sub.length; i++){
              if(access.sub[i].slug === slug[1]){
                permission = access.sub[i].acl;
                break;
              }
            }  
            if(action === 'edit' && permission.hasOwnProperty('edit') && permission.edit === 1){
              return true;
            }else if(action === 'delete' && permission.hasOwnProperty('delete') && permission.delete === 1){
              return true;
            }else if(action === 'download' && permission.hasOwnProperty('download') && permission.download === 1){
              return true;
            }else if(action === 'view' && permission.hasOwnProperty('view') && permission.view === 1){
              return true;
            }else if(action === 'add' && permission.hasOwnProperty('add') && permission.add === 1){
              return true;
            }
          }
        }else{
          for(let i = 0; i < state.accessPermission.length; i++){
            if(state.accessPermission[i].slug === slug){
              access = state.accessPermission[i];
              break;
            }
          }
          if(access.hasOwnProperty('acl')){
            let permission = access.acl;
            if(action === 'edit' && permission.hasOwnProperty('edit') && permission.edit === 1){
              return true;
            }else if(action === 'delete' && permission.hasOwnProperty('delete') && permission.delete === 1){
              return true;
            }else if(action === 'download' && permission.hasOwnProperty('download') && permission.download === 1){
              return true;
            }else if(action === 'view' && permission.hasOwnProperty('view') && permission.view === 1){
              return true;
            }else if(action === 'add' && permission.hasOwnProperty('add') && permission.add === 1){
              return true;
            }
          }
        }

        return false;
    }

    /**
     * Chek if user has Update Permission
     * @param {*} slug 
     */
    hasUpdatePermission(slug){
        if(state.accessPermission.length === 0){
          return false;
        }
        return this.hasPermission(slug,'edit');
    }

    /**
     * Chek if user has Delete Permission
     * @param {*} slug 
     */
    hasDeletePermission (slug) {
        if(state.accessPermission.length === 0){
          return false;
        }
        return this.hasPermission(slug,'delete');
    }

    /**
     * Chek if user has VIEW Permission
     * @param {*} slug 
     */
    hasViewPermission(slug) {
      if(state.accessPermission.length === 0){
        return false;
      }
      let view =  this.hasPermission(slug, 'view');
      if(view){
        return true;
      }
        let add =this.hasPermission(slug,'add');
        let update = this.hasPermission(slug,'update');
        if(add || update){
          return true;
        }
        return false;
    }

}

export default new ACLService();